import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loading from 'react-loading';

import DefaultInput from '../../../components/Input';
import Button from '../../../components/Button';
import Logo from '../../../assets/images/logo-parquearauco.png';
import Icon from '../../../assets/images/logo.png';
import {
  Container,
  Wrapper,
  Title,
  PreTitle,
  IconImg,
  Footer,
  SubTitle,
  CustomLink
} from '../styles';

import { completePassword } from '../../../store/actions/AuthActions';
import { newPasswordSchema } from '../constants';

export default function NewPassword() {
  const dispatch = useDispatch();
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordError, setNewPasswordError] = useState(false);

  const loading = useSelector(state => state.auth.loading);

  function handleNewPasswordOnChange(e) {
    setNewPassword(e.target.value);
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      submit();
    }
  }

  function handleOnClick() {
    submit();
  }

  async function submit() {
    try {
      setNewPasswordError(false);

      await newPasswordSchema.validate({ newPassword }, { abortEarly: false });

      dispatch(completePassword(newPassword));
    } catch (err) {
      if (err.errors) {
        setNewPasswordError(true);
      }
    }
  }

  return (
    <Container>
      <CustomLink to="/">
        <IconImg src={Logo} />
      </CustomLink>

      <Title>
        <PreTitle>SISTEMAS </PreTitle>AUTENTICACIÓN
      </Title>
      <Wrapper>
        <p>Cambiar contraseña</p>
        <SubTitle>
          Como este es su primer inicio de sesión, debe ingresar una nueva
          contraseña.
        </SubTitle>
        <SubTitle>
          La contraseña debe tener: 8 caracteres, mayúsculas (A-Z), minúsculas
          (a-z), números (0-9) y símbolos (#?!@$%^&*-)
        </SubTitle>
        <DefaultInput
          label="NUEVA CONTRASEÑA"
          type="password"
          placeholder="Nueva contraseña"
          placeholderColor="#bbb"
          onKeyDown={handleKeyDown}
          onChange={handleNewPasswordOnChange}
          error={newPasswordError}
        />
        <Button
          text={
            loading ? (
              <Loading height={15} width={15} type="spin" />
            ) : (
              'Ingresar'
            )
          }
          onClick={handleOnClick}
        />
      </Wrapper>
      <Footer>
        <IconImg src={Icon} />
      </Footer>
    </Container>
  );
}
